exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slim-card[data-v-4a5a849f] {\n  padding-top: 16px !important;\n  padding-bottom: 16px !important;\n}\n.hidden-card[data-v-4a5a849f] {\n  display: none !important;\n  height: 0 !important;\n  transition: all 1s ease;\n}\n.show-hidden-card[data-v-4a5a849f] {\n  height: auto !important;\n  display: block !important;\n}", ""]);

// exports
